import { Field, Select } from "src/components/ui";

type DepartmentOption = { id: string; name: string; archivedAt?: string | null };

export function DepartmentField({
  departments,
  value,
  onChange,
  current
}: {
  departments: readonly DepartmentOption[] | undefined;
  value: string;
  onChange: (id: string) => void;
  current?: DepartmentOption | null;
}) {
  const options = (departments ?? []).filter(
    (department) => !department.archivedAt || department.id === current?.id
  );
  // Preserve the saved choice while lookups are loading or unavailable.
  if (current && !options.some((department) => department.id === current.id)) {
    options.push(current);
  }
  return (
    <Field label="Department" hint="The Need department for this engagement">
      <Select value={value} onChange={(event) => onChange(event.target.value)}>
        <option value="">Not recorded</option>
        {options.map((department) => (
          <option
            key={department.id}
            value={department.id}
            disabled={Boolean(department.archivedAt)}
          >
            {department.name}
            {department.archivedAt ? " (archived)" : ""}
          </option>
        ))}
      </Select>
    </Field>
  );
}
